export default "__VITE_ASSET__0ae31cd3__"